// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__2Xvin","Question":"ActiveQuiz_Question__3zmO7"};